import { Link } from 'react-router-dom';

function SideBar({}) {

  return(
    <>
      <div className="left-panel h-100">
        <nav className="nav flex-column p-4 pt-5">
          <li className="nav-link"><Link className="lk-link" to={`/`}>Задания</Link></li>
          <li className="nav-link"><Link className="lk-link" to={`/form_list`}>Формы</Link></li>
          <li className="nav-link"><Link className="lk-link" to={`/asset_list`}>Материалы</Link></li>
          <li className="nav-link"><Link className="lk-link" to={`/tickets`}>Обращения</Link></li>
        </nav>
        <div className='position-absolute bottom-0 start-50 translate-middle-x mb-3'>
          <p className="text-center">МСИ «ФСВОК»</p>
        </div>
      </div>  
    </>
  );
}

export default SideBar